import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { mutationFn, type FollowNarrativeResponseData } from './mutationFn';
import { getQueryKey } from '../useFollowedNarratives/useFollowedNarratives';

import type { FollowedNarrativesResponseData } from '../useFollowedNarratives';

export const useFollowNarrative = () => {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();

  return useMutation({
    mutationFn,
    onSuccess: (data: FollowNarrativeResponseData) => {
      const FOLLOWED_NARRATIVES_QUERY_KEY = getQueryKey();
      queryClient.setQueryData<FollowedNarrativesResponseData[]>(
        FOLLOWED_NARRATIVES_QUERY_KEY,
        (state) => {
          if (typeof state === 'undefined') {
            return state;
          } else {
            return [...state, data];
          }
        }
      );
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Narrative successfully followed',
      });
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to follow narrative',
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKey() });
    },
  });
};
